import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { http } from "@/lib/api";

const StoreCtx = createContext(null);
export const useStore = () => useContext(StoreCtx);

const CART_KEY = "dusa_cart_v1";

export function StoreProvider({ children }) {
  const [data, setData] = useState({ categories: [], products: [], settings: null });
  const [loading, setLoading] = useState(true);
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch { return []; }
  });
  const [cartOpen, setCartOpen] = useState(false);

  const reload = useCallback(() => http.get("/catalog").then((r) => setData(r.data)).finally(() => setLoading(false)), []);
  useEffect(() => { reload(); }, [reload]);
  useEffect(() => { localStorage.setItem(CART_KEY, JSON.stringify(cart)); }, [cart]);

  const addToCart = useCallback((product_id, qty = 1, notes = "", options = {}) => {
    const sig = JSON.stringify(options);
    setCart((c) => {
      const i = c.findIndex((x) => x.product_id === product_id && x.notes === notes && JSON.stringify(x.options || {}) === sig);
      if (i >= 0) return c.map((x, j) => (j === i ? { ...x, qty: Math.min(100, x.qty + qty) } : x));
      return [...c, { key: `${product_id}-${Date.now()}`, product_id, qty, notes, options }];
    });
    setCartOpen(true);
  }, []);
  const updateQty = useCallback((key, qty) => setCart((c) => c.map((x) => (x.key === key ? { ...x, qty: Math.max(1, Math.min(100, qty)) } : x))), []);
  const removeItem = useCallback((key) => setCart((c) => c.filter((x) => x.key !== key)), []);
  const clearCart = useCallback(() => setCart([]), []);

  const lines = useMemo(() => cart.map((c) => ({ ...c, product: data.products.find((p) => p.id === c.product_id) })).filter((l) => l.product), [cart, data.products]);
  const subtotal = lines.reduce((s, l) => s + l.product.price * l.qty, 0);
  const hasQuote = lines.some((l) => l.product.price_type !== "fixed");
  const count = lines.reduce((s, l) => s + l.qty, 0);

  const value = { ...data, loading, reload, cart, lines, subtotal, hasQuote, count, addToCart, updateQty, removeItem, clearCart, cartOpen, setCartOpen };
  return <StoreCtx.Provider value={value}>{children}</StoreCtx.Provider>;
}
